import React from 'react';
export function Marquee() {
  const words = ['PRAYER', 'OUTREACH', 'MISSIONS', 'INTERCESSION', 'REVIVAL', 'PRAYER', 'OUTREACH', 'MISSIONS', 'INTERCESSION', 'REVIVAL'];
  return <div className="w-full bg-midnight py-4 overflow-hidden flex items-center border-y-4 border-gold" data-id="element-248" data-mp="2ikfghlw39jkb">
      <div className="flex whitespace-nowrap animate-marquee" data-id="element-249" data-mp="2dlvwhr122hul">
        {/* Double the array to ensure seamless looping */}
        {[...words, ...words, ...words].map((word, i) => <div key={i} className="flex items-center" data-id="element-250" data-mp="36a9u45o8fc5m" data-mpi={i}>
            <span className="text-2xl md:text-3xl font-display font-bold text-ivory tracking-widest px-8" data-id="element-251" data-mp="31a5a45o47zan">
              {word}
            </span>
            <span className="w-3 h-3 rounded-full bg-gold shrink-0" data-id="element-252" data-mp="2x7igq0bsq6bc" />
          </div>)}
      </div>
    </div>;
}